import about from "./about";
import account from "./account";
import action from "./action";
import billing from "./billing";
import contact from "./contact";
import dashboard from "./dashboard";
import exam from "./exam";
import features from "./features";
import forms from "./forms";
import guest from "./guest";
import onboarding from "./onboarding";
import practice from "./practice";
import resource from "./resource";
import result from "./result";
import subscription from "./subscription";
import navigation from "./navigation";
import feedback from "./feedback";
import checkout from "./checkout";

export default {
    ...about,
    ...account,
    ...action,
    ...billing,
    ...contact,
    ...dashboard,
    ...exam,
    ...features,
    ...forms,
    ...guest,
    ...onboarding,
    ...practice,
    ...resource,
    ...result,
    ...subscription,
    ...navigation,
    ...feedback,
    ...checkout
}